import { IRudiApiRechercherAdresse } from '@app-types/eligibility';

export class EligibilityAddress {
    idAdresseBytel: string;
    zipCode: string;
    inseeCode: string;
    cityLabel: string;
    streetType: string;
    streetLabel: string;
    rivoliCode: string;
    streetNumber: string;
    streetComplement: string;
    linearAddress: string;

    constructor(address?: IRudiApiRechercherAdresse) {
        if (!address || !address.idAdresseBytel) {
            throw new Error('Invalid eligibility address data.');
        }

        this.idAdresseBytel = address.idAdresseBytel;
        this.zipCode = address.codePostal;
        this.inseeCode = address.codeINSEE;
        this.cityLabel = address.commune;
        this.streetType = address.typeVoie;
        this.streetLabel = address.libelleVoie;
        this.rivoliCode = address.codeRivoli;
        this.streetNumber = address.numeroVoie;
        this.streetComplement = address.complementVoie;
        this.linearAddress = address.adresseLineaire;
    }
}
